import { createFileRoute, useParams } from '@tanstack/react-router'
import { useEffect } from 'react'
import { AssetDetailPage } from '../../../../components/AssetDetailPage'
import { useAsset } from '../../../../hooks/useQueries'
import { useUrlTab } from '../../../../hooks/useUrlTab'

export const Route = createFileRoute('/$org/assets/$assetUid/edit')({
  component: AssetDetailEdit,
  validateSearch: () => ({}),
})

function AssetDetailEdit() {
  const { org, assetUid } = useParams({ from: '/$org/assets/$assetUid/edit' })
  const { data: assetData } = useAsset(org, assetUid)

  // Get tab from URL search params, default to 'properties'.
  // Legacy redirect: `?tab=identity` → `?tab=properties` (spec 2026-05-06-02 —
  // Identity tab renamed to Properties). Kept for one release cycle.
  if (typeof window !== 'undefined') {
    const sp = new URLSearchParams(window.location.search)
    if (sp.get('tab') === 'identity') {
      sp.set('tab', 'properties')
      const url = new URL(window.location.href)
      url.search = sp.toString()
      window.history.replaceState({}, '', url.toString())
    }
  }
  // Tab lives in the URL; useUrlTab re-syncs it when the asset changes and on
  // browser back/forward (issue #1017).
  const [activeTab, setActiveTab] = useUrlTab(assetUid, 'properties')

  // Helper function to get asset title
  const getAssetTitle = (asset: Record<string, unknown>) => {
    if (asset.name) {
      return asset.name as string
    }
    if (asset.external_ids && typeof asset.external_ids === 'object' && asset.external_ids !== null) {
      const externalIds = asset.external_ids as Record<string, unknown>
      if (externalIds.code) {
        return externalIds.code as string
      }
    }
    return asset.uid as string
  }

  // Update document title when asset data is available
  useEffect(() => {
    if (assetData) {
      const assetTitle = getAssetTitle(assetData)
      document.title = `${assetTitle} - Buildtory`
    }

    return () => {
      document.title = 'Buildtory'
    }
  }, [assetData])

  return <AssetDetailPage activeTab={activeTab} setActiveTab={setActiveTab} />
}
